import React, { useEffect, useRef, useCallback, useMemo, useState, forwardRef } from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import stringify from '../../utils/stableStringify';

import TileView from 'devextreme-react/tile-view';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { useNavigate } from 'react-router-dom';

import { AntGlobal, AntSession } from '../../utils/AntContext';
import AntLocalization from '../../utils/AntLocalization';
import AntCondition from '../../utils/AntCondition';
import AntAuth from '../../utils/AntAuth';
import cs from '../../utils/const';
import './index.scss';
import AntErrorPage from '../../components/AntErrorPage';

import AntPOSHomeSwitchStore from './AntPOSHomeSwitchStore';
import AntEmployeeShiftCheckin from '../../components/AntMainHeader/AntEmployeeShiftCheckin';
import AntEmployeeShiftCheckout from '../../components/AntMainHeader/AntEmployeeShiftCheckout';

import AntPOSHomeUserName from './AntPOSHomeUserName';
import AntPOSHomeUserActions from './AntPOSHomeUserActions';

export default function (props, ref) {
    const navigate = useNavigate();
    const appGlobal = AntGlobal();

    const sessionValid = useMemo(() => {
        let _canRender = AntCondition.isValid(null, {
            whenSession: {
                session_status: { type: '!=', value: 'Restricted' }
            }
        });

        return _canRender;
    }, []);

    const initItems = useCallback(() => {
        let ar = JSON.parse(
            stringify(
                appGlobal.posNavigation
                    .map((i1) => {
                        var isVisible = AntCondition.isVisible(null, i1);
                        if (!isVisible) return { ...i1, visible: false };

                        if (i1.items instanceof Array) {
                            var ar = i1.items.map((i2) => {
                                return { ...i2, visible: AntCondition.isVisible(null, i2) };
                            });
                            var items = [...ar].filter((f) => f && f.visible);

                            return { ...i1, items, visible: items.length > 0 && AntCondition.isVisible(null, i1) };
                        }
                        return { ...i1, visible: AntCondition.isVisible(null, i1) };
                    })
                    .filter((f) => f && f.visible)
            )
        );

        // let isPOSOnly = AntCondition.isValid(null, {
        //     whenUser: {
        //         UI_display_mode: 'POS_ONLY'
        //     }
        // });
        // if (isPOSOnly) {
        //     var userGroupCode = AntAuth.getSessionInfo('user_group_code');
        //     if (userGroupCode === 'Admin') isPOSOnly = false;
        // }

        // if (!isPOSOnly) {
        //     ar.push({
        //         text: {
        //             vi: 'Thoát',
        //             en: 'Exit'
        //         },
        //         name: 'exit',
        //         dxIcon: 'runner'
        //     });
        // }
        return ar;
    }, []);

    const [mainItems, setMainItems] = React.useState(initItems());

    const itemRender = useCallback(
        (data) => (
            <div className={Boolean(data?.isClicked) ? 'ant-pos-home-card ant-pos-home-card-focused' : 'ant-pos-home-card'}>
                {data.icon && (
                    <img
                        style={{
                            width: 50,
                            display: Boolean(data?.isClicked) ? 'none' : 'inline-block'
                            // opacity: 1
                        }}
                        src={data.icon}
                    ></img>
                )}
                {data.dxIcon && (
                    <i
                        className={'dx-icon dx-icon-' + data.dxIcon}
                        style={{
                            fontSize: 50,
                            display: Boolean(data?.isClicked) ? 'none' : 'inline-block'
                        }}
                    ></i>
                )}

                <LoadIndicator className={'ant-pos-load-indicator'} visible={Boolean(data?.isClicked)} />

                {AntLocalization.translateText(AntCondition.getValue({}, data.text))}
            </div>
        ),
        []
    );

    const onItemClick = useCallback(
        (data) => {
            let newItems = mainItems.map((i) => {
                let isClicked = (i.name && i.name === data?.itemData?.name) || (i.path && i.path === data?.itemData?.path);
                return { ...i, isClicked: Boolean(isClicked) };
            });
            setMainItems(newItems);

            if (data?.itemData?.name === 'exit') {
                window.open('', '_self', '');
                window.close();
                return;
                let isPOSOnly = AntCondition.isValid(null, {
                    whenUser: {
                        UI_display_mode: 'POS_ONLY'
                    }
                });
                if (isPOSOnly) {
                    var userGroupCode = AntAuth.getSessionInfo('user_group_code');
                    var busShortCode = AntAuth.getSessionInfo('business_short_code');
                    var userCode = AntAuth.getSessionInfo('user_code');
                    if (userGroupCode === 'Admin') isPOSOnly = false;
                }
                if (isPOSOnly) {
                    windows.close();
                    // AntAuth.logOut();
                } else {
                    var uiData = localStorage.getItem(cs.System_Code + '-ui-states');
                    if (uiData) uiData = JSON.parse(uiData);
                    if (!uiData) uiData = {};

                    localStorage.setItem(
                        cs.System_Code + '-ui-states',
                        String(
                            stringify({
                                ...uiData,
                                mode: 'WebUI'
                            })
                        )
                    );
                    AntAuth.refreshToken(false, null, () => {
                        window.location.reload();
                    });
                }
            } else if (data?.itemData?.path) {
                const path = data?.itemData?.path;
                setTimeout(
                    (path) => {
                        navigate(path);
                    },
                    500,
                    path
                );
            }
        },
        [mainItems]
    );

    let bgImage = appGlobal.appAssets.images.posBackground;

    const showEmployeeCheckin = useMemo(() => {
        let empCode = AntAuth.getSessionInfo('employee_code');
        let empName = AntAuth.getSessionInfo('employee_name');
        let empSessionStatus = AntAuth.getSessionInfo('employee_session_status');
        let empCodes = AntAuth.getSessionInfo('employee_codes');
        let isValid = empCodes instanceof Array && empCodes.length > 1 && (empSessionStatus !== 'InProgress' || !empCode);
        return isValid;
    }, []);

    const showEmployeeCheckout = useMemo(() => {
        let empCode = AntAuth.getSessionInfo('employee_code');
        let empName = AntAuth.getSessionInfo('employee_name');
        let empSessionStatus = AntAuth.getSessionInfo('employee_session_status');
        let empCodes = AntAuth.getSessionInfo('employee_codes');
        let isValid = empCodes instanceof Array && empCodes.length > 1 && empSessionStatus === 'InProgress' && empCode;
        return isValid;
    }, []);

    return (
        <React.Fragment>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
                className={`ant-app-pos-home`}
            >
                {sessionValid && (
                    <div
                        style={{
                            width: '100%',
                            height: '100%',

                            position: 'absolute',
                            backgroundImage: bgImage ? `url(${bgImage})` : undefined,

                            backgroundRepeat: 'no-repeat',
                            backgroundAttachment: 'fixed',
                            backgroundSize: '100% 100%',
                            filter: 'brightness(0.25)'
                        }}
                        className={`ant-app-backgroundImage`}
                    ></div>
                )}
                <Toolbar>
                    <Item location={'before'} locateInMenu={'auto'}>
                        <AntPOSHomeUserName />
                    </Item>
                    <Item location={'before'} locateInMenu={'auto'}>
                        <AntPOSHomeSwitchStore />
                    </Item>
                    {showEmployeeCheckin && (
                        <Item location={'after'} locateInMenu={'auto'}>
                            <AntEmployeeShiftCheckin visible={true} />
                        </Item>
                    )}
                    {showEmployeeCheckout && (
                        <Item location={'after'} locateInMenu={'auto'}>
                            <AntEmployeeShiftCheckout />
                        </Item>
                    )}
                    <Item location={'after'} locateInMenu={'auto'}>
                        <AntPOSHomeUserActions />
                    </Item>
                </Toolbar>

                {!sessionValid && (
                    <div style={{ backgroundColor: 'white', width: '100%', flexGrow: 1, height: '100%', flex: '1 !important' }}>
                        <AntErrorPage
                            // id={`ant-search-error-page-${props.API.entityName}`}
                            text={AntLocalization.translateText({ vi: 'Không có quyền truy cập !', en: 'Access Denied', fr: 'Accès refusé', es: 'Acceso denegado', id: 'Akses ditolak', ja: 'アクセス拒否', zh: '访问被拒绝', ko: '접근 거부', hi: 'पहुँच अस्वीकृत', ar: 'تم رفض الوصول' })}
                        />
                    </div>
                )}
                {sessionValid && (
                    <ScrollView className={'ant-pos-home-container'} showScrollbar="never" useNative={false}>
                        <TileView
                            className={'ant-pos-home'}
                            items={mainItems}
                            itemRender={itemRender}
                            onItemClick={onItemClick}
                            // showScrollbar={false}
                            style={{ margin: '30px' }}
                            direction={'vertical'}
                            width={560}
                            height={1200}
                            baseItemWidth={160}
                            baseItemHeight={160}
                        />
                    </ScrollView>
                )}
            </div>
        </React.Fragment>
    );
}
